import { Component, inject } from '@angular/core';

import { SessionService } from "../../../services/session.service";

@Component({
    selector: 'menu-items-testing',
    templateUrl: './menu-items-testing.component.html',
    standalone: false
})
export class MenuItemsTestingComponent {
  public session = inject(SessionService);

  triggerWhirlySpinner () {
    this.session.menuTestingVisible = false;
    console.log('triggerWhirlySpinner()');
    this.session.iAmBusy();
    setTimeout(() => {
      console.log('triggerWhirlySpinner() - done');
      this.session.iAmNotBusy();
    }, 5000);
  };
};
